/* ==================================================================
   UTOPIA — PIXEL FIELD (Workstations band)

   Yellow pixels emerge from behind the heading and fill outward across
   the band. The fill is driven by scroll position, not by a timer: the
   further the section has come up the viewport, the further out the
   field has spread. Scroll back up and it draws back in behind the word.

   Once a pixel has arrived it comes alive — a slow wander on its own
   cycle, plus a push from scroll movement, with the larger pixels
   travelling further than the small ones.

   Notes:
   - Pure squares on a pixel grid. No glow, no blur, no rotation.
   - Every shade is a brand yellow. Larger pixels are held at lower
     alpha so the field reads as depth rather than sparkle.
   - The heading's extent is measured from its text rects, not its box.
     .uh-title is a full-width block, so its box would put every pixel
     in two narrow columns either side of centre.
   - The loop only runs while the section is on screen.
   - prefers-reduced-motion draws the settled field once, with no
     travel, no wander and no loop.
================================================================== */
(function(){
  var section = document.getElementById('workstations');
  if(!section || !window.requestAnimationFrame) return;

  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* brand yellows only — second value is the pick weight */
  var SHADES = [
    ['#f0cf1e', 34],   /* utopia yellow */
    ['#ffe36b', 20],   /* lifted */
    ['#c9a70f', 20],   /* dropped */
    ['#fff4bd',  7],   /* highlight, rare */
    ['#8a7411', 19]    /* deep, sits back */
  ];
  var SHADE_TOTAL = 0;
  for(var si = 0; si < SHADES.length; si++) SHADE_TOTAL += SHADES[si][1];
  function shade(){
    var r = Math.random() * SHADE_TOTAL;
    for(var j = 0; j < SHADES.length; j++){ r -= SHADES[j][1]; if(r <= 0) return SHADES[j][0]; }
    return SHADES[0][0];
  }

  /* small sizes dominate; the 6s and 8s are occasional weight */
  var SIZES = [2,2,2,2,3,3,4,4,6,8];
  var GRID = 2;

  function snap(v){ return Math.round(v / GRID) * GRID; }
  function clamp(v,a,b){ return v < a ? a : (v > b ? b : v); }
  function ease(t){ return 1 - Math.pow(1 - t, 3); }
  function easeSoft(t){ return 1 - Math.pow(1 - t, 2); }

  var cv = document.createElement('canvas');
  cv.className = 'uh-px';
  cv.setAttribute('aria-hidden','true');
  section.insertBefore(cv, section.firstChild);

  var ctx = cv.getContext('2d');
  if(!ctx){ section.removeChild(cv); return; }

  var W = 0, H = 0, P = [], built = false, running = false;
  var sp = 0;                                  /* smoothed scroll progress, 0–1 */

  /* scroll energy: fed by the scroll listener, spent by the paint loop */
  var lastY = window.pageYOffset || 0, vel = 0, push = 0;
  window.addEventListener('scroll', function(){
    var y = window.pageYOffset || 0;
    vel += (y - lastY);
    lastY = y;
  }, { passive: true });

  function measure(){
    var r = section.getBoundingClientRect();
    W = Math.max(1, Math.round(r.width));
    H = Math.max(1, Math.round(r.height));
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    cv.width  = Math.round(W * dpr);
    cv.height = Math.round(H * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  /* how far the band has travelled up the viewport, 0 to 1 */
  function progress(){
    var r = section.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var from = vh * 0.92;                      /* section top just entering */
    var to   = vh * 0.12;                      /* section well into view */
    return clamp((from - r.top) / (from - to), 0, 1);
  }

  /* the painted extent of the heading text, not the block it sits in */
  function textRect(el){
    if(!el || !document.createRange) return null;
    try{
      var rg = document.createRange();
      rg.selectNodeContents(el);
      var rects = rg.getClientRects();
      var l = Infinity, t = Infinity, r = -Infinity, b = -Infinity, i, q;
      for(i = 0; i < rects.length; i++){
        q = rects[i];
        if(!q.width || !q.height) continue;
        if(q.left   < l) l = q.left;
        if(q.top    < t) t = q.top;
        if(q.right  > r) r = q.right;
        if(q.bottom > b) b = q.bottom;
      }
      if(l === Infinity) return null;
      return { left:l, top:t, width:r - l, height:b - t };
    } catch(e){ return null; }
  }

  function build(){
    measure();

    var sr = section.getBoundingClientRect();
    var head = section.querySelector('.uh-title') || section.querySelector('h2');
    var hr = textRect(head) || (head ? head.getBoundingClientRect() : null);

    var ox, oy, ow, oh;
    if(hr && hr.width){
      ox = hr.left - sr.left; oy = hr.top - sr.top;
      ow = hr.width;          oh = hr.height;
    } else {
      ox = 0; oy = H * 0.22; ow = W * 0.4; oh = H * 0.18;
    }

    var cx = ox + ow * 0.5;
    var cy = oy + oh * 0.5;
    var gap = Math.min(ow * 0.15, 80);          /* clear of the glyphs before spreading */
    var right = Math.max(60, W - (ox + ow));
    var left  = Math.max(60, ox);
    var pRight = right / (right + left);        /* the heading sits left, so most travel right */

    var narrow = W < 760;
    var count  = narrow ? 130 : Math.round(clamp(W * 0.28, 220, 420));

    P = [];
    for(var k = 0; k < count; k++){
      var t = Math.pow(Math.random(), 0.72);    /* normalised distance from the word */
      var toRight = Math.random() < pRight;
      var reach = toRight ? right : left;
      var sx = toRight ? 1 : -1;

      var x1 = cx + sx * (gap + t * reach);

      /* the band opens out as it gets further from the heading */
      var spread = oh * 0.6 + (H * 0.5 - oh * 0.6) * t;
      var y1 = cy + (Math.random() * 2 - 1) * spread;

      x1 = clamp(x1, 2, W - 10);
      y1 = clamp(y1, 2, H - 10);

      var s = SIZES[(Math.random() * SIZES.length) | 0];
      var a = clamp(0.62 - t * 0.3 + Math.random() * 0.28, 0.08, 0.92);
      if(s >= 6) a *= 0.5;                      /* big ones sit back */

      P.push({
        x0: ox + Math.random() * ow,            /* born behind the heading */
        y0: oy + oh * 0.15 + Math.random() * oh * 0.7,
        x1: x1, y1: y1, sx: sx,
        s: s, c: shade(), a: a,
        /* the further out it lands, the later in the scroll it leaves */
        thr: t * 0.66 + Math.random() * 0.06,
        span: 0.26 + Math.random() * 0.08,
        /* depth — bigger pixels read as nearer, so they travel further */
        dp: (s >= 6 ? 1.5 : s >= 4 ? 1.05 : 0.62) + Math.random() * 0.3,
        wa: calm ? 0 : 1.5 + Math.random() * 3.5,      /* wander amplitude */
        wf: 0.12 + Math.random() * 0.24,               /* wander speed */
        wp: Math.random() * 6.283,
        tw: (!calm && Math.random() < 0.5) ? 0.10 + Math.random() * 0.16 : 0,
        tf: 0.2 + Math.random() * 0.45,
        ph: Math.random() * 6.283
      });
    }
    built = true;
  }

  function paint(now){
    ctx.clearRect(0, 0, W, H);

    /* spend the scroll energy, then let it fall away */
    push += vel * 0.55; vel = 0;
    push *= 0.93;
    push = clamp(push, -90, 90);

    var w = now / 1000;

    for(var k = 0; k < P.length; k++){
      var p = P[k];
      var lp = clamp((sp - p.thr) / p.span, 0, 1);
      if(lp <= 0) continue;

      var x = p.x0 + (p.x1 - p.x0) * ease(lp);
      var y = p.y0 + (p.y1 - p.y0) * easeSoft(lp);

      /* the pixel only comes alive once it is clear of the word */
      var life = clamp((lp - 0.55) / 0.45, 0, 1);
      if(life > 0){
        x += (Math.sin(w * p.wf + p.wp) * p.wa + push * p.dp * p.sx * 0.22) * life;
        y += (Math.cos(w * p.wf * 0.8 + p.wp) * p.wa * 0.7 + push * p.dp * 0.55) * life;
      }

      var a = p.a * clamp((lp - 0.1) / 0.35, 0, 1);
      if(p.tw) a *= 1 + p.tw * Math.sin(w * p.tf + p.ph) * life;

      ctx.globalAlpha = clamp(a, 0, 1);
      ctx.fillStyle = p.c;
      ctx.fillRect(snap(x), snap(y), p.s, p.s);
    }
    ctx.globalAlpha = 1;
  }

  function frame(now){
    if(!running) return;
    var target = progress();
    sp += (target - sp) * 0.14;                 /* eases the fill so it never snaps */
    paint(now);
    requestAnimationFrame(frame);
  }

  function startLoop(){
    if(running) return;
    if(!built) build();
    if(calm){ sp = 1; paint(0); return; }       /* placed, not animated */
    running = true;
    lastY = window.pageYOffset || 0;
    requestAnimationFrame(frame);
  }
  function stopLoop(){ running = false; }

  /* re-seat the field after a resize or a late layout shift */
  var rt = null;
  function reflow(){
    clearTimeout(rt);
    rt = setTimeout(function(){
      if(!built){ measure(); return; }
      build();
      if(!running) paint(0);
    }, 180);
  }

  measure();

  if('IntersectionObserver' in window){
    var vis = new IntersectionObserver(function(en){
      if(en[0].isIntersecting) startLoop(); else stopLoop();
    }, { threshold: 0 });
    vis.observe(section);
  } else {
    startLoop();
  }

  window.addEventListener('resize', reflow);
  window.addEventListener('load', reflow);
  if('ResizeObserver' in window){ new ResizeObserver(reflow).observe(section); }
})();
